import { ApolloClient, InMemoryCache } from "@apollo/client";
import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { setContext } from "@apollo/client/link/context";
import { fetchAuthSession } from "aws-amplify/auth";
import { createEnhancedApolloErrorLink } from "./apollo-error-link";
import { createBreakingChangesFetch } from "shared/src/utils/breaking-changes";

const graphQLUrl = import.meta.env.VITE_GRAPHQL_URL;

const breakingChangesFetch = createBreakingChangesFetch(fetch);

const httpLink = new BatchHttpLink({
  uri: graphQLUrl,
  batchMax: 5,
  batchInterval: 20,
  fetch: breakingChangesFetch,
});

const authLink = setContext(async (_, { headers }) => {
  const session = await fetchAuthSession();
  const token = session?.tokens?.accessToken.toString();

  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    },
  };
});

const errorLink = createEnhancedApolloErrorLink();

const graphQLClient = new ApolloClient({
  cache: new InMemoryCache({
    typePolicies: {
      Provider: { keyFields: ["providerId"] },
      ProviderUser: { keyFields: ["providerUserId"] },
    },
  }),
  link: errorLink.concat(authLink.concat(httpLink)),
  devtools: {
    enabled: false,
  },
});

export default graphQLClient;
